import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDataDisplayerPagination } from "../../components/DataDisplayer/DataDisplayer";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { ISearchParam } from "../BaseApp";
import { EmptyPrinterModel, IPrinterModel } from "./PrintersApp";

interface IPrintersState {
    printers: IPrinterModel[],
    selectedPrinters: IPrinterModel[],
    searchParams: ISearchParam[],
    loading: boolean,
    pagination: IDataDisplayerPagination,
    search?: string
}

const initialState: IPrintersState = {
    printers: [],
    selectedPrinters: [],
    searchParams: [],
    loading: false,
    pagination: {
        count: 0,
        current_page: 0,
        total_pages: 0
    }
}

const printersSlice = createSlice({
    name: "printers",
    initialState,
    reducers: {
        updateAllPrinters: (state: IPrintersState, action: PayloadAction<IPrinterModel[]>) => {
                state.printers = action.payload
        },
        addNewPriner: (state: IPrintersState, action: PayloadAction<IPrinterModel>) => {
            let printers = state.printers

            if (printers.filter(printer => printer.id === action.payload.id).length === 0){
                state.printers.push(action.payload)
            }

        },
        deletePrinter: (state: IPrintersState, action: PayloadAction<{ id: number }>) => {
            const payload = action.payload
            
            let printers = state.printers

            printers = printers.filter(printer => printer.id !== payload.id)

            state.printers = printers

        },
        updatePrinter: (state: IPrintersState, action: PayloadAction<IPrinterModel>) => {
            let printers = state.printers
            
            if (printers && printers.length > 0){
                printers.map((printer) => {
                    if (printer.id === action.payload.id){

                        const locationIndex = printers.findIndex(printer => printer.id === action.payload.id)
                        printers[locationIndex] = action.payload

                    }
                })
            }

            state.printers = printers

        },
        updatePrintersLoadingStatus: (state: IPrintersState, action: PayloadAction<{ loading: boolean }>) => {
            state.loading = action.payload.loading
        },
        updatePrintersPagination: (state: IPrintersState, action: PayloadAction<IDataDisplayerPagination>) => {
            state.pagination = action.payload
        },
        updatePrintersSearch: (state: IPrintersState, action: PayloadAction<{ search: string }>) => {
            state.search = action.payload.search
        },
        updatePrinersSearchParams: (state: IPrintersState, action: PayloadAction<ISearchParam[]>) => {
            state.searchParams = action.payload
        },
        setSelectedPrinters: (state: IPrintersState, action: PayloadAction<IPrinterModel[]>) => {
            state.selectedPrinters = action.payload
        },
    }
})

/**
 * Return all printers
 */
export const useReturnAllPrinters = () => useSelector((state: RootState) => state.printers.printers)

/**
 * Retrun single prunter
 */
export const useReturnSinglePrinter = (id: number) => {
    const printers = useReturnAllPrinters()

    let printer: IPrinterModel = EmptyPrinterModel

    if (printers.length > 0){
        printers.map((singlePrinter) => {
            if (singlePrinter.id === id){
                printer = singlePrinter
            }
        })
    }

    return printer

}

/**
 * Return printers loading status
 */
export const useReturnPrintersLoadingStatus = () => useSelector((state: RootState) => state.printers.loading)

/**
 * Return printers pagination
 */
export const useReturnPrintersPagination = () => useSelector((state: RootState) => state.printers.pagination)

/**
 * Return printers search
 */
export const useReturnPrintersSearch = () => useSelector((state: RootState) => state.printers.search)

/**
 * Return printers search params
 */
export const useReturnPrintersSearchParams = () => useSelector((state: RootState) => state.printers.searchParams)

/**
 * Return selected printers
 */
export const useReturnSelectedPrinters = () => useSelector((state: RootState) => state.printers.selectedPrinters)

export const { 
    updateAllPrinters, 
    addNewPriner, 
    deletePrinter, 
    updatePrinter, 
    updatePrintersLoadingStatus, 
    updatePrintersPagination, 
    updatePrintersSearch, 
    updatePrinersSearchParams, 
    setSelectedPrinters 
} = printersSlice.actions
export default printersSlice.reducer